<template>
  <v-app>
    <go-top></go-top>
    <div style="background-color:white">
      <v-container fluid grid-list-md>
          <v-layout row wrap>
              <!-- <v-flex xs12 style="padding-top: 100px;">
                  <h3>Review your booking</h3>
              </v-flex> -->
              
              <v-flex md1 sm1 xs12 style="text-align:center;padding-top: 200px" class="gd"></v-flex>
              <v-flex md7 sm7 xs12 style="padding-top: 100px;">
                  
                  <div>
                      <v-layout row wrap>
                         <v-flex md3 sm3 xs12>
                             <img style="border-radius:4%" :src=this.reviewBooking.src1 width="100%" height="130px" />
                        
                         </v-flex>
                         <v-flex md9 sm9 xs12 style="padding-left:10px">
                           <h4 v-if="this.reviewBooking.rating === 1" class="enquiry">{{this.reviewBooking.hotelName}} &nbsp;&nbsp;
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-chip
                                        color="#3486d7"
                                        class="white--text"
                                        style="border-radius:5%"
                                        label
                                        small
                                        >
                                        1/5
                                    </v-chip>
                                 </h4>
                           <h4 v-if="this.reviewBooking.rating === 1.5" class="enquiry">{{this.reviewBooking.hotelName}} &nbsp;&nbsp;
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_half</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-chip
                                        color="#3486d7"
                                        class="white--text"
                                        style="border-radius:5%"
                                        label
                                        small
                                        >
                                        1.5/5
                                    </v-chip>
                                 </h4>
                           <h4 v-if="this.reviewBooking.rating === 2" class="enquiry">{{this.reviewBooking.hotelName}} &nbsp;&nbsp;
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-chip
                                        color="#3486d7"
                                        class="white--text"
                                        style="border-radius:5%"
                                        label
                                        small
                                        >
                                        2/5
                                    </v-chip>
                                 </h4>
                           <h4 v-if="this.reviewBooking.rating === 2.5" class="enquiry">{{this.reviewBooking.hotelName}} &nbsp;&nbsp;
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_half</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-chip
                                        color="#3486d7"
                                        class="white--text"
                                        style="border-radius:5%"
                                        label
                                        small
                                        >
                                        2.5/5
                                    </v-chip>
                                 </h4>
                           <h4 v-if="this.reviewBooking.rating === 3" class="enquiry">{{this.reviewBooking.hotelName}} &nbsp;&nbsp;
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-chip
                                        color="#3486d7"
                                        class="white--text"
                                        style="border-radius:5%"
                                        label
                                        small
                                        >
                                        3/5
                                    </v-chip>
                                 </h4>
                           <h4 v-if="this.reviewBooking.rating === 3.5" class="enquiry">{{this.reviewBooking.hotelName}} &nbsp;&nbsp;
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_half</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-chip
                                        color="#3486d7"
                                        class="white--text"
                                        style="border-radius:5%"
                                        label
                                        small
                                        >
                                        3.5/5
                                    </v-chip>
                                 </h4>
                                <h4 v-if="this.reviewBooking.rating === 4" class="enquiry">{{this.reviewBooking.hotelName}} &nbsp;&nbsp;
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_border</v-icon>
                                     <v-chip
                                        color="#3486d7"
                                        class="white--text"
                                        style="border-radius:5%"
                                        label
                                        small
                                        >
                                        4/5
                                    </v-chip>
                                 </h4>
                                 <h4 v-if="this.reviewBooking.rating === 4.5" class="enquiry">{{this.reviewBooking.hotelName}} &nbsp;&nbsp;
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star_half</v-icon>
                                     <v-chip
                                        color="#3486d7"
                                        class="white--text"
                                        style="border-radius:5%"
                                        label
                                        small
                                        >
                                        4.5/5
                                    </v-chip>
                                 </h4>

                                 <!-- ========================================================================  -->

                                 <h4 v-if="this.reviewBooking.rating === 5" class="enquiry">{{this.reviewBooking.hotelName}} &nbsp;&nbsp;
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-icon size="17px" color="#fdd835">star</v-icon>
                                     <v-chip
                                        color="#3486d7"
                                        class="white--text"
                                        style="border-radius:5%"
                                        label
                                        small
                                        >
                                        5/5
                                    </v-chip>
                                 </h4>
                             
                             <p class="grey--text" style="font-weight:thin">{{this.reviewBooking.billingAddress}}</p>
                             <v-layout row wrap>
                                 <v-flex md3 sm3 xs12>
                                     <p class="chck">Check-In Time:</p>
                                     <p class="grey--text">From {{this.reviewBooking.checkInTime}} PM</p>
                                 </v-flex>
                                 <v-flex md3 sm3 xs12>
                                     <p class="chck">Check-Out Time:</p>
                                     <p class="grey--text">Before {{this.reviewBooking.checkOutTime}} AM</p>   
                                 </v-flex>
                             </v-layout>
                             
                         </v-flex>
                         <v-flex xs12>
                             <v-divider color="#ff336d" style="margin-top:-10px"></v-divider>
                         </v-flex>
                         <v-flex xs12>
                             <v-container class="brdr">
                                <v-layout row wrap>
                                    <v-flex md9 sm9 xs12>
                                        <h4 class="enquiry" style="color:#ff336d">DELUXE ROOM</h4>
                                        
                                        <p class="grey--text" style="font-weight:thin">{{this.selectedAdult}} Adults + {{this.selectedChildren}} Children ({{this.selectedRoom}} Rooms)</p>
                                        <!-- <p class="grey--text" style="font-weight:thin"><span  class="black--text">Rate : </span>
                                        <span class="primary--text">2400 </span>
                                        <span>(per night for single room)</span></p> -->
                                        <span  class="black--text">Rate :    </span>
                                        <span class="primary--text">{{this.reviewBooking.actualRate}} </span>
                                        <span class="grey--text">(per night for single room)</span>
                                         <p class="grey--text" style="font-weight:thin"><span class="black--text">INCLUDED :  </span>
                                         <span v-if="this.reviewBooking.breakfast === true"><v-icon style="padding-left:20px;" size="15px">emoji_food_beverage</v-icon>&nbsp;Breakfast</span>
                                         <span v-if="this.reviewBooking.parkingPlace === true" style="padding-left:20px;"><v-icon size="15px">local_taxi</v-icon>&nbsp;Parking</span>
                                         <span v-if="this.reviewBooking.telephone === true" style="padding-left:20px;"><v-icon size="15px">phone</v-icon>&nbsp;Telephone</span>
                                         <span style="padding-left:20px;">more...</span></p>
                                    </v-flex>
                                    <v-flex md3 sm3 xs12>
                                        <img style="border-radius:4%" :src=this.reviewBooking.src2 width="100%" height="130px" />
                                    </v-flex>
                                </v-layout>
                             </v-container>
                         </v-flex>
                         <v-flex xs12>
                             <v-container class="brdr">
                               <v-form ref="form2" v-model="valid" lazy-validation>
                                 <v-layout row wrap>
                                     <v-flex xs12>
                                         <h4 class="enquiry" style="color:black">Enter your details</h4>
                                     </v-flex>
                                     <v-flex md2 sm2 xs12>
                                        <v-autocomplete
                                            v-model="selectedTitle"
                                            :items="titles"
                                            label="Title"
                                            item-text="titles"
                                            item-value="titles"
                                        ></v-autocomplete>
                                     </v-flex>
                                     <v-flex md10 sm10 xs12>
                                         <v-text-field v-model="form2.fullName" label="Please enter your full name *" :rules="emptyRule" required></v-text-field>
                                     </v-flex>
                                     <v-flex xs12>
                                         <v-text-field v-model="form2.email" label="Please enter your Email ID *" :rules="[rules.email]" required></v-text-field>
                                     </v-flex>
                                     <v-flex xs12>
                                         <v-text-field type="Number" v-model="form2.mobileNumber" label="Please enter your Mobile number *" :rules="[rules.phNo]" required></v-text-field>
                                     </v-flex>
                                     <v-flex xs12>
                                         <b-form-checkbox v-model="form2.haveGst">I have a GST number (optional)</b-form-checkbox>
                                         <!-- <v-checkbox label="I have a GST number" v-model="form.same"></v-checkbox> -->
                                     </v-flex>
                                     <v-flex xs12 v-if="form2.haveGst === true">
                                         <v-text-field v-model="form2.gstNumber" label="Please enter GST number"></v-text-field>
                                     </v-flex>
                                     <!-- <v-flex xs12 v-if="form2.haveGst === true">
                                         <v-text-field v-model="form2.companyName" label="Please enter Company name"></v-text-field>
                                     </v-flex>
                                     <v-flex xs12 v-if="form2.haveGst === true">
                                         <v-text-field v-model="form2.companyAddress" label="Please enter Company address"></v-text-field>
                                     </v-flex> -->
                                 </v-layout>
                                 </v-form>
                             </v-container>
                         </v-flex>

                         <v-flex xs12>
                             <v-container class="brdr">
                               <v-form ref="form4" v-model="valid" lazy-validation>
                                <v-layout row wrap>
                                   <v-flex xs12>
                                     <v-switch v-model="coupon" label="Have you any Coupon Code ?" color="primary" hide-details></v-switch>
                                   </v-flex>
                                   <v-flex xs12 md10 sm10 v-if="coupon === true">
                                      <v-text-field v-model="form4.couponCode" label="Please enter you Coupon Code"></v-text-field>
                                   </v-flex>
                                   <v-fles xs12 md2 sm2 v-if="coupon === true">
                                     <v-btn color="#ff336d" style="border-radius:20px" class="white--text" block depressed @click="coupon()">Submit</v-btn>
                                   </v-fles>
                                </v-layout>
                               </v-form>
                             </v-container>
                         </v-flex>
                      </v-layout>
                  </div>
              </v-flex>

              <v-flex md4 sm4 xs12 style="padding-top: 70px;padding-right: 20px">
                  <v-container>
                      <v-card class="elevation-5 opct">
                           <v-btn style="margin-bottom:30px;pointer-events: none;font-size:12px" color="#ff336d" class="white--text" large block depressed>CHECK-IN | CHECK-OUT | GUESTS | ROOMS</v-btn>
                         
                            <v-form ref="form5" v-model="valid" lazy-validation>
                            <v-layout row wrap>
                         <v-flex xs12 md12 sm12>
                             <v-layout row wrap>
                                  <v-flex xs12 md6 sm6>
                                       <v-dialog ref="dialog" v-model="checkInModel" persistent lazy full-width width="310px">
                           <v-text-field
                             append-icon="event"
                             slot="activator"
                             v-model="form5.checkIn"
                             label="Check-In"
                             readonly
                           ></v-text-field>
                              <v-date-picker v-model="form5.checkIn" @change="update()" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="checkInModel = false">Ok</v-btn>
                              </v-date-picker>
                    </v-dialog>
                                  </v-flex>
                                  <v-flex xs12 md6 sm6>
                                       <v-dialog ref="dialog" v-model="checkOutModel" persistent lazy full-width width="310px">
                           <v-text-field
                             append-icon="event"
                             slot="activator"
                             v-model="form5.checkOut"
                             label="Check-Out"
                             readonly
                           ></v-text-field>
                              <v-date-picker v-model="form5.checkOut" @change="update()" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="checkOutModel = false">Ok</v-btn>
                              </v-date-picker>
                    </v-dialog>
                                  </v-flex>

                                  <v-flex xs12 md4 sm4>
                                     <v-autocomplete
                                     v-model="selectedRoom"
                                     :items="rooms"
                                     color="primary"
                                     label="Rooms"
                                     item-text="rooms"
                                     item-value="rooms"
                                     @change="update()"
                                   ></v-autocomplete>
                                  </v-flex>

                                  <v-flex xs12 md4 sm4>
                                      <v-autocomplete
                                     v-model="selectedAdult"
                                     :items="adults"
                                     color="primary"
                                     label="Adult(s)"
                                     item-text="adults"
                                     item-value="adults"
                                   ></v-autocomplete>
                                  </v-flex>

                                  <v-flex xs12 md4 sm4>
                                      <v-autocomplete
                                     v-model="selectedChildren"
                                     :items="children"
                                     color="primary"
                                     label="Children"
                                     item-text="children"
                                     item-value="children"
                                   ></v-autocomplete>
                                  </v-flex>
                             </v-layout>
                         </v-flex>
          
                       </v-layout>
                     </v-form>
                      </v-card>
                   </v-container>







                   <v-container>
                      <v-card class="elevation-5 opct">
                          <h2 style="text-align:center;padding-top:20px;" class="enquiry">Payment Details</h2>
                          <p style="text-align:center; color:#ff336d" class="contact_tag">Please make your payment for booking</p>
                            <v-form ref="form6" v-model="valid" lazy-validation>
                             <v-layout row wrap>
                                <v-flex xs12 md2 sm2></v-flex>
                             <v-flex xs12 md8 sm8>
                             <v-layout row wrap>
                                  <v-flex xs12 md6 sm6><h6>Basic Price</h6></v-flex>
                                  <v-flex xs12 md2 sm2><!-- <h6>:</h6> --></v-flex>
                                  <v-flex xs12 md4 sm4 style="text-align:right"><h6>{{this.basePrice}}</h6></v-flex>
                                  <br/>
                                  <v-flex xs12>
                                      <v-divider color="grey" style="margin-bottom:-5px;margin-top:-10px;"></v-divider>
                                  </v-flex>

                                  <v-flex xs12 md6 sm6>
                                   <h6>CGST</h6>
                                   <h6>SGST</h6>
                                   <h6>IGST</h6></v-flex>
                                  <v-flex xs12 md2 sm2><!-- <h6>:</h6> --></v-flex>
                                  <v-flex xs12 md4 sm4 style="text-align:right">
                                    <h6>{{this.cgst}}</h6>
                                    <h6>{{this.sgst}}</h6>
                                    <h6>{{this.igst}}</h6>
                                  </v-flex>
                                  <v-flex xs12 style="margin-top:-25px">
                                      <v-divider color="grey" style="margin-bottom:-5px;"></v-divider>
                                  </v-flex>

                                  <v-flex xs12 md6 sm6><h6>GST</h6></v-flex>
                                  <v-flex xs12 md2 sm2><!-- <h6>:</h6> --></v-flex>
                                  <v-flex xs12 md4 sm4 style="text-align:right"><h6>{{this.gst}}</h6></v-flex>
                                  <br/>
                                  <v-flex xs12>
                                      <v-divider color="grey" style="margin-bottom:-5px;margin-top:-10px;"></v-divider>
                                  </v-flex>
                                  <v-flex xs12 md6 sm6><h6>Total Payable</h6></v-flex>
                                  <v-flex xs12 md2 sm2><!-- <h6>:</h6> --></v-flex>
                                  <v-flex xs12 md4 sm4 style="text-align:right;color:#ff336d"><h5>{{this.payble}}</h5></v-flex>
                                  <br/>
                                  <br/>
                                  <v-flex xs12 style="text-align:center">
                                    <span>  <b-form-checkbox v-model="form6.agree">I agree to the</b-form-checkbox> <span class="primary--text logopoint txt_dec" @click.stop="policy = true" >hotel booking policy </span> of aimroindia.com</span>
                                  </v-flex>
                                   <v-dialog
                                 v-model="policy"
                                  max-width="700"
                                  >
    
                                 <v-card style="background-color: #ffffff" class="redius">
                                  <div style="color:red">

                                 <v-card flat color="transparent">
                                  
                                  <v-layout row wrap style="padding-left: 15px">
                                    <v-flex xs12 md1 sm1></v-flex>
                                    <v-flex xs12 md11 sm11>
                                    <h4 style="text-align:left;color:#ff336d">Hotel Polices</h4>
                                    </v-flex>
                                    <v-flex xs12 md1 sm1>
                                         <v-icon size="20px" color="green">check_circle</v-icon>
                                    </v-flex>
                                    <v-flex xs12 md11 sm11>
                                      <p class="grey--text">{{this.reviewBooking.hotelPolicy1}}
                                      </p>
                                    </v-flex>
                                <v-flex xs12 md1 sm1>
                                         <v-icon size="20px" color="green">check_circle</v-icon>
                                    </v-flex>
                                    <v-flex xs12 md11 sm11>
                                      <p class="grey--text">{{this.reviewBooking.hotelPolicy2}}
                                      </p>
                                    </v-flex>
                                <v-flex xs12 md1 sm1>
                                         <v-icon size="20px" color="green">check_circle</v-icon>
                                    </v-flex>
                                    <v-flex xs12 md11 sm11>
                                      <p class="grey--text">{{this.reviewBooking.hotelPolicy3}}
                                      </p>
                                    </v-flex>
                                <v-flex xs12 md1 sm1>
                                         <v-icon size="20px" color="green">check_circle</v-icon>
                                    </v-flex>
                                    <v-flex xs12 md11 sm11>
                                      <p class="grey--text">{{this.reviewBooking.hotelPolicy4}}
                                      </p>
                                    </v-flex>

                                <v-flex xs12 md1 sm1>
                                         <v-icon size="20px" color="green">check_circle</v-icon>
                                    </v-flex>
                                    <v-flex xs12 md11 sm11>
                                      <p class="grey--text">{{this.reviewBooking.hotelPolicy5}}
                                      </p>
                                    </v-flex>
                              </v-layout>
                              
                             </v-card>
         
                              
                               </div>
                               <br/>
                            </v-card>
                           </v-dialog>
                             </v-layout>
                         </v-flex>

                         <v-flex xs12 md2 sm2></v-flex>

                         <br>

                         <v-flex xs12 md2 sm2></v-flex>
                         <v-flex xs12 md8 sm8>
                           <v-btn :disabled="bnt" style="margin-bottom:30px" color="#ff336d" class="white--text" :loading="pay" large block depressed @click="payment()">PAY NOW &nbsp;₹ {{this.payble}}</v-btn>
                         
                     <v-dialog
                             v-model="successDialog"
                             max-width="700"
                             persistent
                        >
    
                                <v-card style="background-color: #ffffff" class="redius">
                                  <div style="color:red">

                                <v-card flat color="transparent">
                                  
                                  <v-layout row wrap>
                                    <v-flex xs12 style="text-align:center;margin-bottom:40px">
                                      <v-icon color="pink" size="70">check_circle</v-icon>
                                    </v-flex>
                                    <v-flex xs12 style="text-align:center">
                                      <h5 class="grey--text">Your Booking Request ID : {{this.bookingId}}</h5>
                                    </v-flex>
                                   <v-flex xs12 style="text-align:center">
                                      <h2 class="black--text">You successfully created your booking</h2>
                                    </v-flex>
                                    <v-flex xs12 style="text-align:center">
                                      <h4 class="purple--text">Kindly enlist your traveller list for this booking</h4>
                                    </v-flex>
                                    <v-flex xs12 style="text-align:center">
                                      <v-btn color="primary" text @click="notnow()">Not Now</v-btn>
                                      <v-btn color="green" class="white--text" text @click="travellerlist()">Add Traveller List</v-btn>
                                    </v-flex>
                              </v-layout>
                            </v-card>
         
                              
                       </div>
                      <br/>
                     </v-card>
                     </v-dialog>
                         </v-flex>

                         <v-flex xs12 md2 sm2></v-flex>
          
                       </v-layout>
                     </v-form>
                      </v-card>
                   </v-container>
                             </v-flex>
                         </v-layout>
                         
              </v-container>
    </div>
  </v-app>
</template>


<script>

import config from "./../../config.json";
import GoTop from '@inotom/vue-go-top';
import { log } from 'util';
export default {
  components: {
    GoTop
  },
  data() {
    return {
        bnt: false,
        edit: false,
        dialog: false,
        otpDialog: false,
        model: null,
        pay: false,
        send: false,
        successDialog: false,
        policy: false,
        chng: false,
        checkInModel: false,
        checkOutModel: false,
        coupon:false,
        days: null,
        basePrice: null,
        gstPer: null,
        gst: null,
        cgst: null,
        sgst: null,
        igst: null,
        payble: null,

        rt: null,
        otp1:null,
           

        /* form3: {
          otp2: null
        }, */

      entries: [],

      valid: true,

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",

        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        phNo: value => {
          const pattern = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[789]\d{9}$/;
          return pattern.test(value) || "10 digit number";
        },
      },

      selectedTitle: "Mr",
      titles: ["Mr", "Mrs", "Ms"],

      city: sessionStorage.city,
      room: sessionStorage.room,
      adult: sessionStorage.adult,
      baccha: sessionStorage.baccha,
      hey: sessionStorage.hey,
      hello: sessionStorage.hello,
      
      passwordShow: false,
      isLoading: false,

      selectedRoom: "1",
      rooms: ["1", "2", "3", "4", "5"],
      
      selectedAdult: "1",
      adults: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],

      selectedChildren: "0",
      children: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],

      form: {
        UserName: null,
        password: null
      },


      form1: {
          name: null
      },

      form2: {
         fullName: null,
         email: null,
         mobileNumber: null,
         haveGst: false,
         gstNumber: null,
         companyName: null,
         companyAddress: null,
      },
      form4: {
        couponCode:  null
      },

      form5: {
         checkIn: new Date().toISOString().substr(0, 10),
         checkOut: null
      },

      form6: {
        agree:true
      },

      loggedInUserID: sessionStorage.loggedInUserID,
      stateCode: null,

      bookingId: null,

      form3: {
        otp2: null
      },

      auth: "euk+IJoa19hNemzXr9C0YSJfIWl9xoyuaVTw1pUg0oY=",

      reviewBooking: {
        id: null,
        hotelId: null,
        hotelName: null,
        rating: null,
        billingAddress: null,
        checkInTime: null,
        checkOutTime: null,
        hotelPolicy1: null,
        hotelPolicy2: null,
        hotelPolicy3: null,
        hotelPolicy4: null,
        hotelPolicy5: null,
        roomCategoryId: null,
        roomCategoryName: null,
        actualRate: null,
        breakfast: null,
        telephone: null,
        parkingPlace: null,
        bathroom: null,
        swimmingPool: null,
        blanket: null,
        pillows: null,
        fullTimeService: null,
        restaurant: null,
        src1: null,
        src2: null,
        availableRoom: null
      },

       key: "QwQyQAaY",
       salt: "8Ebolpkn7p",
       txnid: "b728690de9f3635d5671",
       name: "anil",
       email: "webanilsidhu@gmail.com",
       amount: 10,
       phone: 7003672536,
       surl: "http://worldwin.co.in/",
       furl: "http://infosyst.in/",
       productInfo: "xyzabc",
       service_provider: "payu_paisa"

    };
  },
  mounted() {


   
 

   this.axios
      .get(config.API + `ReviewBooking/${this.$route.params.id}`, {
      })
      .then(res => {
         this.reviewBooking.id = res.data.id;
         this.reviewBooking.hotelId = res.data.hotelId;
         this.reviewBooking.hotelName = res.data.hotelName;
         this.reviewBooking.rating = res.data.rating;
         this.reviewBooking.billingAddress = res.data.billingAddress;
         this.reviewBooking.checkInTime = res.data.checkInTime;
         this.reviewBooking.checkOutTime = res.data.checkOutTime;
         this.reviewBooking.hotelPolicy1 = res.data.hotelPolicy1;
         this.reviewBooking.hotelPolicy2 = res.data.hotelPolicy2;
         this.reviewBooking.hotelPolicy3 = res.data.hotelPolicy3;
         this.reviewBooking.hotelPolicy4 = res.data.hotelPolicy4;
         this.reviewBooking.hotelPolicy5 = res.data.hotelPolicy5;
         this.reviewBooking.roomCategoryId = res.data.roomCategoryId;
         this.reviewBooking.roomCategoryName = res.data.roomCategoryName;
         this.reviewBooking.actualRate = res.data.actualRate;
         this.reviewBooking.breakfast = res.data.breakfast;
         this.reviewBooking.telephone = res.data.telephone;
         this.reviewBooking.parkingPlace = res.data.parkingPlace;
         this.reviewBooking.bathroom = res.data.bathroom;
         this.reviewBooking.swimmingPool = res.data.swimmingPool;
         this.reviewBooking.blanket = res.data.blanket;
         this.reviewBooking.pillows = res.data.pillows;
         this.reviewBooking.fullTimeService = res.data.fullTimeService;
         this.reviewBooking.restaurant = res.data.restaurant;
         this.reviewBooking.src1 = res.data.src1;
         this.reviewBooking.src2 = res.data.src2;
         this.reviewBooking.availableRoom = 4;
         

         
         var _date1 = new Date(this.form5.checkIn);
         var _date2 = new Date(this.form5.checkOut);

         var different_in_time = _date2.getTime() - _date1.getTime();

         var different_in_days = different_in_time / (1000 * 3600 * 24);
        this.days = different_in_days;

        //==========================================================

        var _basicPrice = JSON.parse(this.reviewBooking.actualRate * this.days * this.selectedRoom);
        this.basePrice = _basicPrice;

        //==========================================================
        if (this.stateCode == 19) {
          if (this.basePrice < 1000) {
          this.gstPer = 0;
          this.gst = 0;
          this.cgst = 0.00;
          this.sgst = 0.00;
          this.igst = 0.00;
        } 
        if (this.basePrice >= 1000 && this.basePrice <= 2499) {
          var _gstRate = JSON.parse((this.basePrice * 12) / 100);
          this.gst = _gstRate;
          this.gstPer = 12;
          this.cgst = JSON.parse(((this.basePrice * 12) / 100) / 2);
          this.sgst = JSON.parse(((this.basePrice * 12) / 100) / 2);
          this.igst = 0.00;
        }
        if (this.basePrice >= 2500 && this.basePrice <= 7499) {
          var _gstRate = JSON.parse((this.basePrice * 18) / 100);
          this.gst = _gstRate;
          this.gstPer = 18;
          this.cgst = JSON.parse(((this.basePrice * 18) / 100) / 2);
          this.sgst = JSON.parse(((this.basePrice * 18) / 100) / 2);
          this.igst = 0.00;
        }
        if (this.basePrice >= 7500) {
          var _gstRate = JSON.parse((this.basePrice * 28) / 100);
          this.gst = _gstRate;
          this.gstPer = 28;
          this.cgst = JSON.parse(((this.basePrice * 28) / 100) / 2);
          this.sgst = JSON.parse(((this.basePrice * 28) / 100) / 2);
          this.igst = 0.00;
        }
        }
        else {
          if (this.basePrice < 1000) {
          this.gstPer = 0;
          this.gst = 0;
          this.cgst = 0.00;
          this.sgst = 0.00;
          this.igst = 0.00;
        } 
        if (this.basePrice >= 1000 && this.basePrice <= 2499) {
          var _gstRate = JSON.parse((this.basePrice * 12) / 100);
          this.gst = _gstRate;
          this.gstPer = 12;
          this.cgst = 0.00;
          this.sgst = 0.00;
          this.igst = JSON.parse((this.basePrice * 12) / 100);
        }
        if (this.basePrice >= 2500 && this.basePrice <= 7499) {
          var _gstRate = JSON.parse((this.basePrice * 18) / 100);
          this.gst = _gstRate;
          this.gstPer = 18;
          this.cgst = 0.00;
          this.sgst = 0.00;
          this.igst = JSON.parse((this.basePrice * 18) / 100);
        }
        if (this.basePrice >= 7500) {
          var _gstRate = JSON.parse((this.basePrice * 28) / 100);
          this.gst = _gstRate;
          this.gstPer = 28;
          this.cgst = 0.00;
          this.sgst = 0.00;
          this.igst = JSON.parse((this.basePrice * 28) / 100);
        }
        }
        

        

        

       //==========================================================


       var _payblePrice = JSON.parse(this.basePrice + this.gst);
       this.payble = _payblePrice;

      })
      .catch(err => {
        console.log(err.message);
      });

      //======================================= NEXT DATE =================================================

      var today = new Date();
      var tomorrow = new Date(today.getTime() + (24 * 60 * 60 * 1000)).toISOString().substr(0, 10);
      this.form5.checkOut = tomorrow;

      this.axios
        .get(config.API + "UserDetails/" + sessionStorage.loggedInUserID, {
        })
        .then(res => {
          this.stateCode = res.data.stateCode;
          this.form2.gstNumber = res.data.gstNumber;

          if (this.form2.gstNumber != null) {
            this.form2.haveGst = true
          }
        })

  },
  

 

  
  

 methods: {

   update() {

     if (this.selectedRoom <= this.reviewBooking.availableRoom) {
      var _date1 = new Date(this.form5.checkIn);
         var _date2 = new Date(this.form5.checkOut);

         var different_in_time = _date2.getTime() - _date1.getTime();

         var different_in_days = different_in_time / (1000 * 3600 * 24);
        this.days = different_in_days;

      if (this.days > 0) {
        this.chng = true;
        this.bnt = false;



        //==========================================================

        var _basicPrice = JSON.parse(this.reviewBooking.actualRate * this.days * this.selectedRoom);
        this.basePrice = _basicPrice;

        //==========================================================

        if (this.stateCode == 19) {
         if (this.basePrice < 1000) {
          this.gstPer = 0;
          this.gst = 0;
          this.cgst = 0.00;
          this.sgst = 0.00;
          this.igst = 0.00;
        } 
        if (this.basePrice >= 1000 && this.basePrice <= 2499) {
          var _gstRate = JSON.parse((this.basePrice * 12) / 100);
          this.gst = _gstRate;
          this.gstPer = 12;
          this.cgst = JSON.parse(((this.basePrice * 12) / 100) / 2);
          this.sgst = JSON.parse(((this.basePrice * 12) / 100) / 2);
          this.igst = 0.00;
        }
        if (this.basePrice >= 2500 && this.basePrice <= 7499) {
          var _gstRate = JSON.parse((this.basePrice * 18) / 100);
          this.gst = _gstRate;
          this.gstPer = 18;
          this.cgst = JSON.parse(((this.basePrice * 18) / 100) / 2);
          this.sgst = JSON.parse(((this.basePrice * 18) / 100) / 2);
          this.igst = 0.00;
        }
        if (this.basePrice >= 7500) {
          var _gstRate = JSON.parse((this.basePrice * 28) / 100);
          this.gst = _gstRate;
          this.gstPer = 28;
          this.cgst = JSON.parse(((this.basePrice * 28) / 100) / 2);
          this.sgst = JSON.parse(((this.basePrice * 28) / 100) / 2);
          this.igst = 0.00;
        }
        }
        else {
          if (this.basePrice < 1000) {
          this.gstPer = 0;
          this.gst = 0;
          this.cgst = 0.00;
          this.sgst = 0.00;
          this.igst = 0.00;
        } 
        if (this.basePrice >= 1000 && this.basePrice <= 2499) {
          var _gstRate = JSON.parse((this.basePrice * 12) / 100);
          this.gst = _gstRate;
          this.gstPer = 12;
          this.cgst = 0.00;
          this.sgst = 0.00;
          this.igst = JSON.parse((this.basePrice * 12) / 100);
        }
        if (this.basePrice >= 2500 && this.basePrice <= 7499) {
          var _gstRate = JSON.parse((this.basePrice * 18) / 100);
          this.gst = _gstRate;
          this.gstPer = 18;
          this.cgst = 0.00;
          this.sgst = 0.00;
          this.igst = JSON.parse((this.basePrice * 18) / 100);
        }
        if (this.basePrice >= 7500) {
          var _gstRate = JSON.parse((this.basePrice * 28) / 100);
          this.gst = _gstRate;
          this.gstPer = 28;
          this.cgst = 0.00;
          this.sgst = 0.00;
          this.igst = JSON.parse((this.basePrice * 28) / 100);
        }
        }
        

        

        

       //==========================================================


       var _payblePrice = JSON.parse(this.basePrice + this.gst);
       this.payble = _payblePrice;

        this.chng = false;
     }
     else {
       this.$toaster.error("Check-Out Date should be greater than Check-In Date");
       this.bnt = true;
     }
     }else {
       this.$toaster.error( "Only " + this.reviewBooking.availableRoom + " rooms are available");
       this.bnt = true;
     }

     
    

    
   },

    payment() {
      this.pay = true;
     if (this.$refs.form2.validate()) {
       var transactionCode = Math.floor(100000000000 + Math.random() * 900000000000);
       this.bookingId = transactionCode
       this.axios
          .post(
            config.API + `BookingDetails`,
            {
              transactionId: this.bookingId,
              hotelId: this.reviewBooking.hotelId,
              roomCategoryId: this.reviewBooking.roomCategoryId,
              pricePerRoom: this.reviewBooking.actualRate,
              title: this.selectedTitle,
              fullName: this.form2.fullName,
              email: this.form2.email,
              mobileNumber: this.form2.mobileNumber,
              haveGst: this.form2.haveGst,
              gstNumber: this.form2.gstNumber,
              companyName: this.form2.companyName,
              companyAddress: this.form2.companyAddress,
              checkInDate: this.form5.checkIn,
              checkOutDate: this.form5.checkOut,
              room: this.selectedRoom,
              adult: this.selectedAdult,
              children: this.selectedChildren,
              basicPrice: this.basePrice,
              gstPer: this.gstPer,
              gst: this.gst,
              cgst: this.cgst,
              sgst: this.sgst,
              igst: this.igst,
              totalPayable: this.payble,
              agree: this.form6.agree
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.successDialog = true;
            this.pay = false;
            sessionStorage.setItem("transactionId", this.bookingId);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.pay = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
        this.pay = false;
      }
    },

    notnow() {
      this.successDialog = false;
      this.$router.push(`/myBooking`);
      this.$toaster.success(`Here you see your upcoming booking`);
    },
    travellerlist() {
      this.$router.push(`/addTraveller/` + this.bookingId);
    },
    coupon() {
      this.$router.push(`/aimro`);
    }
 },
computed: {
  /* btn: function () {
    bolt.launch({
            key: $('#key').val(),
            txnid: $('#txnid').val(),
            hash: $('#hash').val(),
            amount: $('#amount').val(),
            firstname: $('#fname').val(),
            email: $('#email').val(),
            phone: $('#mobile').val(),
            productinfo: $('#pinfo').val(),
            udf5: $('#udf5').val(),
            surl: $('#surl').val(),
            furl: $('#surl').val()
        }, { responseHandler: function (BOLT) {
            console.log(BOLT.response.txnStatus);
            if (BOLT.response.txnStatus != 'CANCEL') {
                //Salt is passd here for demo purpose only. For practical use keep salt at server side only.
                var fr = '<form action=\"' + $('#surl').val() + '\" method=\"post\">' +
		'<input type=\"hidden\" name=\"key\" value=\"' + BOLT.response.key + '\" />' +
		'<input type=\"hidden\" name=\"salt\" value=\"' + $('#salt').val() + '\" />' +
		'<input type=\"hidden\" name=\"txnid\" value=\"' + BOLT.response.txnid + '\" />' +
		'<input type=\"hidden\" name=\"amount\" value=\"' + BOLT.response.amount + '\" />' +
		'<input type=\"hidden\" name=\"productinfo\" value=\"' + BOLT.response.productinfo + '\" />' +
		'<input type=\"hidden\" name=\"firstname\" value=\"' + BOLT.response.firstname + '\" />' +
		'<input type=\"hidden\" name=\"email\" value=\"' + BOLT.response.email + '\" />' +
		'<input type=\"hidden\" name=\"udf5\" value=\"' + BOLT.response.udf5 + '\" />' +
		'<input type=\"hidden\" name=\"mihpayid\" value=\"' + BOLT.response.mihpayid + '\" />' +
		'<input type=\"hidden\" name=\"status\" value=\"' + BOLT.response.status + '\" />' +
		'<input type=\"hidden\" name=\"hash\" value=\"' + BOLT.response.hash + '\" />' +
		'</form>';
                var form = jQuery(fr);
                jQuery('body').append(form);
                form.submit();
            }
        },
            catchException: function (BOLT) {
                alert(BOLT.message);
            }
        });
  } */
}
 
};
</script>

<style scoped>
@import '../../HomeCss/home.css';

@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Bree+Serif|Squada+One&display=swap');
</style>

<style scoped>
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 50px;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.enquiry {
    font-family: 'Bree Serif', serif;
}
.contact_tag {
    font-family: 'Space Mono', monospace;
}
.chck {
    margin-bottom: 0px !important;
    margin-top: 16px !important;
}
.brdr {
  border: 1px solid #000000;
  border-radius: 10px;
}

</style>
